var render, staticRenderFns
import script from "./dynamic-form-item.vue?vue&type=script&lang=js&"
export * from "./dynamic-form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c7812",
  null
  
)

export default component.exports